import { render, staticRenderFns } from "./VrstaSkupaEdit.vue?vue&type=template&id=9ff6a8ee&scoped=true&"
import script from "./VrstaSkupaEdit.vue?vue&type=script&lang=js&"
export * from "./VrstaSkupaEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff6a8ee",
  null
  
)

export default component.exports